import { put, select, takeLatest } from "redux-saga/effects"
import { Types as LoaderTypes } from "model/graphql"
import { Creators as analyzeFactorSensitivityCreators } from "modules/analyze-factor-sensitivity-details/model"
import { chain, get } from "lodash"

function* handleLoadSuccess({ resource, data }) {
  if (resource === "groupedFactorSensitivityContributors") {
    const { selectedGroup } = yield select(state => ({
      selectedGroup: get(state, "modules.analyzeFactorSensitivityDetails.selectedGroup"),
    }))

    if (selectedGroup) {
      const selectedGroupExists = chain(data)
        .get("model.simulation.groupedFactorSensitivityContributors")
        .some(item => item.id === selectedGroup.id)
        .value()

      if (!selectedGroupExists) {
        yield put(analyzeFactorSensitivityCreators.hideGroup())
      }
    }
  }
}

export function* saga() {
  yield takeLatest(LoaderTypes.LOAD_SUCCESS, handleLoadSuccess)
}
